import {Message} from 'element-ui';
let messageInstance = null;
const resetMessage = (options) => {
    if(messageInstance){
        messageInstance.close();
    }
    messageInstance = Message(options);
};
['error','success','info','warning'].forEach(type => {
    resetMessage[type] = options => {
        if(typeof options === 'string'){
            options = {
                message: options
            }
        }
        options.type = type;
        // 错误提示延长至 10s 且可手动关闭: 默认 3s 太短, 来不及复制报错文案/traceId
        if(type === 'error'){
            if(options.duration === undefined) options.duration = 10000;
            options.showClose = true;
        }
        return resetMessage(options);
    }
})

export default resetMessage;